import { WidgetSizeT } from "../../../localTypes/WidgetSizeT";

export const noteWidgetSizes: WidgetSizeT[] = [
  { w: 2, h: 1 },
  { w: 2, h: 2 },
];
